import { Listener } from './Listener';
import { log } from '../InternalLogger';
import { detectFormTest } from '../../helpers/detect-form-test';
export class LoggerListener extends Listener {
    formStart(formName, inputName) {
        log('Form start', {
            formName,
            inputName,
        });
    }
    formNavigate(formName, formStep, navigationAction, data) {
        log('Form navigate', {
            formName,
            formStep,
            navigationAction,
            data,
        });
    }
    formSubmit(formName, data) {
        log('Form submit', {
            formName,
            data,
            isTest: detectFormTest(data),
        });
    }
    chatStart() {
        log('Chat start');
    }
    chatEnd() {
        log('Chat end');
    }
    pageReady() {
        log('JS loaded');
    }
    setConsent(essential, functional, marketing) {
        log('Consent update', {
            essential,
            functional,
            marketing,
        });
    }
}
